import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose, ascend, descend, groupWith, head, prop, sortWith } from 'ramda';
import { withRouter } from 'react-router-dom';

import Card from '../../../../../components/Card';
import { routes } from '../../../../index';

const propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
};

const Certifications = ({ history, user }) => {
  const grouped = compose(
    groupWith((a, b) => a.certificationId == b.certificationId),
    sortWith([descend(prop('certificationId')), descend(prop('reportingPeriodId')), ascend(prop('status'))]),
  )(user.userCertifications);

  return (
    <Card>
      <Card.Header>Certifications</Card.Header>
      <Card.Body>
        {grouped.length == 0 ? (
          <p>This user does not have any certifications</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Certification</th>
                <th>Status</th>
                <th>Certification Date</th>
              </tr>
            </thead>
            <tbody>
              {grouped.map((group) => {
                const certification = head(group);
                return (
                  <tr
                    className="clickableRow"
                    key={certification.id}
                    onClick={() =>
                      history.push(
                        routes.admin.users.profile.certificationBuilder(user.id, certification.certificationId),
                      )
                    }
                  >
                    <td>{certification.name}</td>
                    <td>{certification.status}</td>
                    <td>{moment(certification.createdAt).format('MM/DD/YYYY')}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Card.Body>
    </Card>
  );
};

Certifications.propTypes = propTypes;

export default withRouter(Certifications);
